export const CLEAR_NOTIFICATIONS_STORE = 'CLEAR_NOTIFICATIONS_STORE'
export const SET_NOTIFICATIONS_LIST = 'SET_NOTIFICATIONS_LIST'
export const SET_SELECTED_NOTIFICATION = 'SET_SELECTED_NOTIFICATION'

export const SET_SHOULD_RELOAD_NOTIFICATIONS_LIST =
  'SET_SHOULD_RELOAD_NOTIFICATIONS_LIST'
